@if (isMobile()) {
  <ul class="navbar-list mobile">
    <li
      class="nav-item"
      *ngFor="let item of navItems()"
      [routerLink]="item.link"
      routerLinkActive="current"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="item.onClick?.()"
    >
      <span class="d-flex align-items-center icon-gap">
        <div class="icon" [class]="item.icon"></div>
        <div>{{ item.label }}</div>
      </span>
    </li>

    @if (!loggedInUser()) {
      <div class="nav-item" (click)="onLoginClick()">
        <span class="d-flex align-items-center icon-gap">
          <div class="fa-solid fa-user icon"></div>
          <div>{{ cmsCopy().login }}</div>
        </span>
      </div>
    } @else {
      <accordion [isAnimated]="true" class="user-menu-accordion">
        <accordion-group #loginGroup class="menu-accordion">
          <div
            accordion-heading
            class="toggle-container flex-toggle-container"
            [ngClass]="{ collapsed: !loginGroup.isOpen }"
            [attr.aria-expanded]="!loginGroup.isOpen"
          >
            <span class="d-flex align-items-center icon-gap">
              <div class="fa-solid fa-user icon"></div>
              <div>{{ loggedInUser()?.name?.first }}</div>
            </span>
            <i class="toggle-chevron"></i>
          </div>

          <div [routerLink]="cmsCopy().yourAccount.link" class="nav-accordion-item">
            {{ cmsCopy().yourAccount.name }}
          </div>
          <div (click)="onLogoutClick()" class="nav-accordion-item">
            {{ cmsCopy().logout }}
          </div>
        </accordion-group>
      </accordion>
    }
  </ul>
} @else {
  <ul class="navbar-list">
    <li
      class="nav-item"
      *ngFor="let item of navItems()"
      [routerLink]="item.link"
      routerLinkActive="current"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="item.onClick?.()"
    >
      <span>{{ item.label }}</span>
    </li>

    @if (!loggedInUser()) {
      <div class="nav-item" (click)="onLoginClick()">
        <div>{{ cmsCopy().login }}</div>
      </div>
    } @else {
      <app-header-menu-user
        [username]="loggedInUser()?.name?.first"
        [yourAccountLink]="cmsCopy().yourAccount.link"
        [yourAccountNameLabel]="cmsCopy().yourAccount.name"
        [logoutLabel]="cmsCopy().logout"
      ></app-header-menu-user>
    }
  </ul>
}
